import React from 'react';

import icon from '../images/google.svg';

export default function GoogleIcon() {
  return <img src={icon} alt="google" style={{ height: 18, width: 18 }} />;
}
